import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob, IJobType } from './jobs'
import { createTask_deliverCargo } from './taskDeliverCargo'
import { createFetchCargoTask } from './taskFetchCargo'
import { createTask_stackCargo } from './taskStackCargo'

const jobType: IJobType = 'stack'
export const register = () => registerJob(jobType, runJob)

function runJob(job: IJob) {
  jobLogger.assertJobType(job, jobType)

  let st = jobLogger.assertStack(job)

  // Seed job tasks
  if (job.tasks.length === 0) {
    job.isFailed = false
    job.tasks = []
    let task = createFetchCargoTask(st.i, st.j, null, st.holdsType, false)
    job.tasks.push(task)

    task = createTask_deliverCargo(st.i, st.j, st.holdsType, true)
    job.tasks.push(task)

    task = createTask_stackCargo(st.i, st.j, st.holdsType)
    job.tasks.push(task)
    return
  }

  if (job.tasks.length > 0) {
    advanceTask(job)
  }
}
